import styled, { css } from 'styled-components'
import { Text, ButtonUnstyled, Input, InputWrapper } from '@sketch/components'
import {
  StyledSelectPopover as SelectPopover,
  IconWrapper as Icon,
  StyledChevron as Chevron,
} from 'modules/shares/components/SearchBar/SearchBar.styles'
import { ReactComponent as AntiClockwiseArrowCircle } from '@sketch/icons/anti-clockwise-arrow-circle-16'

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: 24px;

  [aria-label='Clear'] {
    /* to avoid the clear button showing on top of the options menu */
    margin-left: -72px; /* stylelint-disable-line scales/space */
  }
`

export const Options = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`

export const ToggleWrapper = styled(Text.Div).attrs({
  textStyle: 'copy.tertiary.standard.D',
})`
  width: 80px;
  padding: 9px 4px 8px 8px; /* stylelint-disable-line scales/space */
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 31px;
  cursor: pointer;
`

export const StyledSelectPopover = styled(SelectPopover)`
  width: 256px;
  /* needed to override the 100px min height, which is short for this menu */
  max-height: 550px !important; /* stylelint-disable-line declaration-no-important */
`

export const StyledAntiClockwiseArrowCircle = styled(AntiClockwiseArrowCircle)`
  width: 12px;
  height: 12px;
`

export const ResetButton = styled(ButtonUnstyled)(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.D};
    padding: 16px 12px 8px 20px;
    display: flex;
    align-items: center;

    ${StyledAntiClockwiseArrowCircle} {
      margin-right: 8px;
    }
  `
)

export const DatesWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    color: ${theme.colors.foreground.secondary.C};
    font-size: ${theme.fontSizes.C};
    align-items: center;
    padding: 0 20px 12px;
    justify-content: space-between;

    ${InputWrapper} {
      width: 90px;
    }
  `
)

export const DatePicker = styled(Input).attrs({
  type: 'date',
})(
  ({ theme }) => css`
    width: 90px;
    border-radius: 6px;
    border: 1px solid ${theme.colors.border.B};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1) inset;
    background-color: ${theme.colors.background.secondary.A};
    margin: 0;
    color: ${theme.colors.state.disabled};
    font-size: ${theme.fontSizes.D};
  `
)

export const IconWrapper = styled(Icon)``
export const StyledChevron = styled(Chevron)``
